export const demoUser = () => {
    return sessionStorage.getItem('isDemo') === 'true';
};